import { useLocalizedName } from '../../lib/localizedName';

/** The two driver-name fields every call-centre order carries. */
export interface HasDriverNames {
  driverName?: string | null;
  driverNameAr?: string | null;
}

/**
 * The driver's name, in the till's language.
 *
 * One helper rather than the same two-line expression on the card, in the
 * drawer and in the dispatch toast — a driver who reads "Ahmed" on the board
 * and "أحمد" in the drawer looks like two people to whoever is on the phone.
 *
 * Delegates to `nameFor`, so it inherits the fallback the rest of the till
 * already uses: when the driver's name was only ever filled in on one side,
 * that one is shown rather than a blank. `driverNameAr` is resolved live from
 * `Security_Users` by the server and falls back to the single denormalised name
 * on the order, so a driver who has since been removed still reads correctly —
 * in whichever language it was recorded in, which is the best that row can do.
 */
export function useDriverName(): (order: HasDriverNames | null | undefined) => string {
  const localized = useLocalizedName();
  return (order) =>
    order ? localized({ name: order.driverName, name_ar: order.driverNameAr }) : '';
}
